import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { DtcAPI, extractError } from "../lib/api";
import { DtcCodeChip } from "./DtcCodeChip";

export function VehicleDtcHistory({ vehicleId }) {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        if (!vehicleId) return;
        DtcAPI.vehicleHistory(vehicleId)
            .then((d) => setItems(d.items || []))
            .catch((e) => setErr(extractError(e)))
            .finally(() => setLoading(false));
    }, [vehicleId]);

    if (loading) return <div className="text-sm opacity-60">Loading…</div>;
    if (err) return <div className="text-sm text-rose-600">{err}</div>;
    if (!items.length) {
        return (
            <div data-testid="dtc-history-empty" className="rounded-xl border border-dashed p-6 text-sm text-center opacity-60">
                No DTC scans recorded for this vehicle.
            </div>
        );
    }

    return (
        <div data-testid="dtc-history-list" className="rounded-xl border bg-card divide-y">
            {items.map((row) => (
                <div key={row.id} data-testid={`dtc-history-row-${row.id}`} className="p-3 flex items-center justify-between gap-3">
                    <div className="flex items-center gap-3 flex-1 min-w-0">
                        <DtcCodeChip code={row.code} severity={row.decoded?.severity} description={row.decoded?.description} />
                        <div className="min-w-0">
                            <div data-testid={`dtc-history-row-${row.id}-desc`} className="text-sm font-medium truncate">
                                {row.decoded?.description || "Unknown DTC"}
                            </div>
                            <div className="text-[11px] opacity-60">
                                {new Date(row.read_at).toLocaleString()}
                                {row.mileage_at_read != null && <> · {row.mileage_at_read.toLocaleString()} km</>}
                                {row.cleared_at && <> · <span className="text-emerald-700 dark:text-emerald-300">cleared</span></>}
                            </div>
                        </div>
                    </div>
                    {row.job_card_id && (
                        <Link
                            to={`/jobs/${row.job_card_id}`}
                            data-testid={`dtc-history-row-${row.id}-job-link`}
                            className="text-xs underline whitespace-nowrap"
                        >
                            {row.job_number || "open job"}
                        </Link>
                    )}
                </div>
            ))}
        </div>
    );
}
